import type { SearchResult } from 'conversational-search-client';

// conv-search exposes only an orientation enum, not a true per-clip ratio, and Storyblocks
// vertical footage is standardized to 9:16 — so these representative ratios are accurate enough
// to lay results out by orientation instead of pillarboxing everything into a 16:9 box.
const PORTRAIT_ASPECT_RATIO = 9 / 16;
const LANDSCAPE_ASPECT_RATIO = 16 / 9;
const SQUARE_ASPECT_RATIO = 1;

export function deriveAspectRatio(orientation: SearchResult['orientation']): number {
    if (orientation === 'portrait') return PORTRAIT_ASPECT_RATIO;
    if (orientation === 'square') return SQUARE_ASPECT_RATIO;
    return LANDSCAPE_ASPECT_RATIO;
}
